<template>
    <div class="clock">
        <div class="LCD">
            <div class="hours">{{ hours }}</div>
            <div class="divider">:</div>
            <div class="minutes">{{ minutes }}</div>
            <div class="divider">:</div>
            <div class="seconds">{{ seconds }}</div>
        </div>
        <div style="padding: 0 2px;">|</div>
        <div class="date">{{ formattedDate }}</div>
    </div>
</template>

<script>
    export default {
        name: "DigitalClock",
        data() {
            return {
                hours: 0,
                minutes: 0,
                seconds: 0,
                day: ''
            }
        },
        mounted() {
            setInterval(() => this.setTime(), 1000);
            this.getDay();
        },
        methods: {
            setTime() {
                const date = new Date();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();
                hours = hours <= 9 ? `${hours}`.padStart(2, 0) : hours;
                minutes = minutes <= 9 ? `${minutes}`.padStart(2, 0) : minutes;
                seconds = seconds <= 9 ? `${seconds}`.padStart(2, 0) : seconds;
                this.hours = hours;
                this.minutes = minutes;
                this.seconds = seconds;
            },
            getDay() {
                var week = ['SUN', 'Thứ 2', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
                var cd = new Date();
                this.day = week[cd.getDay()];
            }
        },
        computed: {
            formattedDate() {
                const date = new Date();
                const day = date.getDate().toString().padStart(2, "0");
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear().toString();

                return `${day}/${month}/${year}`;
            },
        },
    }
</script>

<style scoped>
    .LCD {
        display: flex;
    }
    .LCD > div {
        font-size: 13px;
        color: var(--text-color);
    }

    .clock {
        display: flex;
        align-items: center;
    }

    .date {
        padding-right: 10px;
        color: var(--text-color);
    }
</style>